<template>
  <div class="formItem">
    <template>
      <!-- 级联 -->
      <el-cascader
        ref="Cascader"
        style="width: 100%"
        v-if="item.componentType === 'Cascader' && showCascader"
        :clearable="item.props.clearable"
        :filterable="item.props.filterable"
        :disabled="!item.editable || lockedInfo ? true : false"
        :placeholder="item.placeholder"
        expand-trigger="click"
        v-model.lazy="stringOrArrayValue"
        :props="cascaderProps"
        @focus="handleFocus('Cascader')"
        @change="handleUpdate($event)"
      >
      </el-cascader>
      <!-- 评分 -->
      <el-rate
        class="w-rate"
        v-model.lazy="formData[item.id]"
        style="width: 100%"
        v-if="item.componentType === 'Rate'"
        :max="item.props.max"
        :disabled="
          formDisabledValue || !item.editable || lockedInfo ? true : false
        "
        :show-score="item.props.showscore"
        :text-color="item.props.color"
        :colors="[item.props.color, item.props.color, item.props.color]"
        :allow-half="item.props.allowhalf"
        :void-icon-class="`rate-icon-${item.props.shape}-void`"
        :icon-classes="[
          `rate-icon-${item.props.shape}`,
          `rate-icon-${item.props.shape}`,
          `rate-icon-${item.props.shape}`,
        ]"
        @change="handleUpdate($event)"
      >
      </el-rate>
      <!-- 文本 -->
      <!--   :minlength="item.props.minlength"
        :maxlength="item.props.maxlength" -->
      <el-input
        v-model.lazy="formData[item.id]"
        style="width: 100%"
        v-if="item.componentType === 'Input'"
        :show-word-limit="item.props.showwordlimit"      
        :placeholder="item.placeholder"
        :clearable="item.props.clearable"
        :show-password="item.props.showpassword"
        :disabled="!item.editable || lockedInfo ? true : false"
        :prefix-icon="item.props.prefixicon"
        :suffix-icon="item.props.suffixicon"
        @change="handleUpdate($event)"
      >
        <template v-if="item.props.prepend !== ''" slot="prepend">{{
          item.props.prepend
        }}</template>
        <template v-if="item.props.append !== ''" slot="append">{{
          item.props.append
        }}</template>
      </el-input>
      <!-- :minlength="item.props.minlength"
        :maxlength="item.props.maxlength" -->
      <el-input
        style="width: 100%"
        type="textarea"
        v-if="item.componentType === 'Textarea'"
        v-model.lazy="formData[item.id]"
        :show-word-limit="item.props.showwordlimit"        
        :placeholder="item.placeholder"
        :clearable="item.props.clearable"
        :disabled="!item.editable || lockedInfo ? true : false"
        @change="handleUpdate($event)"
      >
      </el-input>
      <!-- 数值 -->
      <el-input-number
        style="width: 100%"
        v-if="item.componentType === 'InputNumber'"
        v-model.lazy.number="formData[item.id]"
        :min="item.props.min"
        :max="item.props.max"
        :step="item.props.step"
        :step-strictly="item.props.stepstrictly"
        :precision="item.props.precision"
        :disabled="!item.editable || lockedInfo ? true : false"
        :controls-position="item.props.controlsposition"
        :placeholder="item.placeholder"
        @change="handleUpdate($event)"
      >
      </el-input-number>
      <!-- 下拉 -->
      <el-select
        ref="Select"
        style="width: 100%"
        v-if="item.componentType === 'Select'"
        v-model.lazy="stringOrArrayValue"
        :placeholder="item.placeholder"
        :multiple="!item.single"
        collapse-tags
        :disabled="!item.editable || lockedInfo ? true : false"
        :clearable="item.props.clearable"
        :filterable="item.props.filterable"
        :allow-create="item.props.allowcreate"
        @focus="handleFocus('Select')"
        @change="handleUpdate($event)"
      >
        <el-option
          v-for="(item, index) in selectValue"
          :key="index"
          :label="item"
          :value="item"
        >
          <span style="float: left">{{ item }}</span>
          <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item2.value }}</span> -->
        </el-option>
      </el-select>
      <!-- 开关 -->
      <el-switch
        style="width: 100%"
        v-if="item.componentType === 'Switch'"
        v-model.lazy="formData[item.id]"
        :disabled="!item.editable || lockedInfo ? true : false"
        :active-text="item.props.activetext"
        :inactive-text="item.props.inactivetext"
        :active-color="item.props.activecolor"
        :inactive-color="item.props.inactivecolor"
        :active-value="item.props.activevalue"
        :inactive-value="item.props.inactivevalue"
        @change="handleUpdate($event)"
      >
      </el-switch>
      <!-- 滑块 -->
      <el-slider
        style="width: 100%"
        v-if="item.componentType === 'Slider'"
        v-model="sliderValue"
        :min="item.props.min"
        :max="item.props.max"
        :disabled="!item.editable || lockedInfo ? true : false"
        :step="item.props.step"
        :show-stops="item.props.showstops"
        :show-input="item.props.showinput"
        :range="item.props.range"
        @change="handleUpdate($event)"
      >
      </el-slider>
      <!-- 时间 -->
      <!-- <el-time-select
        style="width: 100%"
        v-if="item.componentType === 'Timeselect'"
        v-model.lazy="formData[item.id]"
        :disabled="!item.editable || lockedInfo ? true : false"
        :clearable="item.props.clearable"
        :picker-options="item.props.pickeroptions"
        :placeholder="item.placeholder"
        :prefix-icon="item.props.prefixicon"
        value-format="HH:mm:ss"
        @change="handleUpdate($event)"
      >
      </el-time-select> -->

      <!-- 日期 -->
      <template v-if="item.componentType === 'DatePicker'">
        <el-date-picker
          style="width: 100%"
          v-if="datePickerType[item.dataType] === 'year'"
          v-model="yearValue"
          type="year"
          :placeholder="item.placeholder"
          :clearable="item.props.clearable"
          :disabled="!item.editable || lockedInfo ? true : false"
          :prefix-icon="item.props.prefixicon"
          :format="dateFormatterMap(item.dataType)"
          value-format="yyyy"
          @change="handleUpdate($event)"
        >
        </el-date-picker>
        <el-date-picker
          style="width: 100%"
          v-else-if="datePickerType[item.dataType] === 'month'"
          v-model.lazy="monthValue"
          type="month"
          :placeholder="item.placeholder"
          :clearable="item.props.clearable"
          :disabled="!item.editable || lockedInfo ? true : false"
          :prefix-icon="item.props.prefixicon"
          :format="dateFormatterMap(item.dataType)"
          value-format="yyyy-MM"
          @change="handleUpdate($event)"
        >
        </el-date-picker>
        <el-date-picker
          style="width: 100%"
          v-else-if="datePickerType[item.dataType] === 'date'"
          v-model.lazy="dateValue"
          type="date"
          :placeholder="item.placeholder"
          :clearable="item.props.clearable"
          :disabled="!item.editable || lockedInfo ? true : false"
          :prefix-icon="item.props.prefixicon"
          :format="dateFormatterMap(item.dataType)"
          value-format="yyyy-MM-dd"
          @change="handleUpdate($event)"
        >
        </el-date-picker>
        <el-time-picker
          style="width: 100%"
          v-else-if="datePickerType[item.dataType] === 'time'"
          v-model.lazy="timeValue"
          :disabled="!item.editable || lockedInfo ? true : false"
          :clearable="item.props.clearable"
          :placeholder="item.placeholder"
          value-format="HH:mm:ss"
          @change="handleUpdate($event)"
        >
        </el-time-picker>
        <el-date-picker
          style="width: 100%"
          v-else
          v-model.lazy="datetimeValue"
          type="datetime"
          :placeholder="item.placeholder"
          :clearable="item.props.clearable"
          :disabled="!item.editable || lockedInfo ? true : false"
          :prefix-icon="item.props.prefixicon"
          :format="dateFormatterMap(item.dataType)"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="handleUpdate($event)"
        >
        </el-date-picker>
      </template>
      <!-- 明细表单选为下拉形式 -->
      <template v-if="item.componentType === 'Radio'">
        <el-radio-group
          style="width: 100%"
          v-model.lazy="formData[item.id]"
          :disabled="!item.editable || lockedInfo ? true : false"
          @change="handleUpdate($event)"
        >
          <div v-if="item.props.radiotype === 'yuan'">
            <el-radio
              v-for="(item, index) in selectValue"
              :key="index"
              :label="item"
              >{{ item }}</el-radio
            >
          </div>
          <div v-if="item.props.radiotype === 'button'">
            <el-radio-button
              v-for="(item, index) in selectValue"
              :key="index"
              :label="item"
              >{{ item }}</el-radio-button
            >
          </div>
        </el-radio-group>
      </template>

      <!-- 明细表多选为下拉形式 -->
      <template v-if="item.componentType === 'Checkbox'">
        <el-checkbox-group
          style="width: 100%"
          v-model.lazy="stringOrArrayValue"
          :disabled="!item.editable || lockedInfo ? true : false"
          @change="handleUpdate($event)"
        >
          <div v-if="item.props.checkboxtype === 'fang'">
            <el-checkbox
              v-for="(item, index) in selectValue"
              :key="index"
              :label="item"
              >{{ item }}</el-checkbox
            >
          </div>
          <div v-if="item.props.checkboxtype === 'button'">
            <el-checkbox-button
              v-for="(item, index) in selectValue"
              :key="index"
              :label="item"
              >{{ item }}</el-checkbox-button
            >
          </div>
        </el-checkbox-group>
      </template>
      <!-- 进度条 -->
      <el-progress
        v-if="item.componentType === 'Progress'"
        :percentage="progressValue"
        :type="item.props.linetype"
        :disabled="!item.editable || lockedInfo ? true : false"
      >
      </el-progress>

      <!-- 图片 -->
      <template v-if="item.componentType === 'ImageUpload'">
        <!-- 多图 -->
        <WImageUpload
          v-if="item.props.display === 'multiple'"
          :item="item"
          :accept="item.props.accept"
          :limit="item.props.limit"
          :size="item.props.size"
          :disabled="!item.editable || lockedInfo ? true : false"
          v-model="formData[item.id]"
          @handleUpdate="handleUpdate($event)"
        />
        <!-- 单图 -->
        <WSingleImageUpload
          v-else
          :item="item"
          :accept="item.props.accept"
          :disabled="!item.editable || lockedInfo ? true : false"
          :limit="item.props.limit"
          :size="item.props.size"
          v-model="formData[item.id]"
          @handleUpdate="handleUpdate($event)"
        />
      </template>

      <!-- 附件 -->
      <template v-if="item.componentType === 'AttchmentUpload'">
        <WAttachmentUpload
          :display="item.props.display"
          :accept="item.props.accept"
          :disabled="!item.editable || lockedInfo ? true : false"
          :limit="item.props.limit"
          :size="item.props.size"
          v-model="formData[item.id]"
          @handleUpdate="handleUpdate($event)"
        />
      </template>

      <!-- 定位 -->
      <WLocation
        v-if="item.componentType === 'Location'"
        :item="item"
        :disabled="!item.editable || lockedInfo ? true : false"
        :formData="formData"
        @handleUpdate="handleUpdate($event)"
      />

      <!-- 列表 -->
      <WList
        v-if="item.componentType === 'List'"
        :item="item"
        :disabled="!item.editable || lockedInfo ? true : false"
        :formData="formData"
        @listViewShow="listViewShow()"
        @handleUpdate="handleUpdate($event)"
      />

      <!-- 签名 -->
      <WSign
        v-if="item.componentType === 'Sign'"
        :item="item"
        :disabled="!item.editable || lockedInfo ? true : false"
        v-model="formData[item.id]"
        @handleUpdate="handleUpdate($event)"
      />

      <!-- 自动编号 -->
      <el-input
        v-model.lazy="formData[item.id]"
        style="width: 100%"
        v-if="item.componentType === 'Serial'"
        :placeholder="item.placeholder"
        :clearable="item.props.clearable"
        :disabled="!item.editable || lockedInfo ? true : false"
        :prefix-icon="item.props.prefixicon"
        :suffix-icon="item.props.suffixicon"
        @change="handleUpdate($event)"
      >
        <template v-if="item.props.prepend !== ''" slot="prepend">{{
          item.props.prepend
        }}</template>
        <template v-if="item.props.append !== ''" slot="append">{{
          item.props.append
        }}</template>
      </el-input>

      <!-- 身份证 -->
      <el-input
        v-model.lazy="formData[item.id]"
        style="width: 100%"
        v-if="item.componentType === 'IdentityCard'"
        :placeholder="item.placeholder"
        :clearable="item.props.clearable"
        :disabled="!item.editable || lockedInfo ? true : false"
        :prefix-icon="item.props.prefixicon"
        :suffix-icon="item.props.suffixicon"
        @change="handleUpdate($event)"
      >
        <template v-if="item.props.prepend !== ''" slot="prepend">{{
          item.props.prepend
        }}</template>
        <template v-if="item.props.append !== ''" slot="append">{{
          item.props.append
        }}</template>
      </el-input>

      <!-- 电话 -->
      <el-input
        v-model.lazy="formData[item.id]"
        style="width: 100%"
        v-if="item.componentType === 'PhoneNumber'"
        :placeholder="item.placeholder"
        :clearable="item.props.clearable"
        :disabled="!item.editable || lockedInfo ? true : false"
        :prefix-icon="item.props.prefixicon"
        :suffix-icon="item.props.suffixicon"
        @change="handleUpdate($event)"
      >
        <template v-if="item.props.prepend !== ''" slot="prepend">{{
          item.props.prepend
        }}</template>
        <template v-if="item.props.append !== ''" slot="append">{{
          item.props.append
        }}</template>
      </el-input>

      <!-- 邮箱 -->
      <el-autocomplete
        style="width: 100%"
        v-if="item.componentType === 'Email'"
        v-model="formData[item.id]"
        :fetch-suggestions="querySearch"
        :placeholder="item.placeholder"
        :clearable="item.props.clearable"
        :disabled="!item.editable || lockedInfo ? true : false"
        :prefix-icon="item.props.prefixicon"
        :suffix-icon="item.props.suffixicon"
        :trigger-on-focus="false"
        @select="handleSelect"
        @change="handleUpdate($event)"
      >
        <template slot-scope="{ item }">
          <div class="name">{{ item }}</div>
        </template>
        <template v-if="item.props.prepend !== ''" slot="prepend">{{
          item.props.prepend
        }}</template>
        <template v-if="item.props.append !== ''" slot="append">{{
          item.props.append
        }}</template>
      </el-autocomplete>

      <!-- 金额 -->
      <el-input
        v-model.lazy="formData[item.id]"
        type="number"
        style="width: 100%"
        v-if="item.componentType === 'Amount'"
        :placeholder="item.placeholder"
        :clearable="item.props.clearable"
        :disabled="!item.editable || lockedInfo ? true : false"
        :prefix-icon="item.props.prefixicon"
        :suffix-icon="item.props.suffixicon"
        @change="handleUpdate($event)"
      >
        <template v-if="item.props.prepend !== ''" slot="prepend">{{
          item.props.prepend
        }}</template>
        <template v-if="item.props.append !== ''" slot="append">{{
          item.props.append
        }}</template>
      </el-input>
    </template>

    <!-- 列表弹窗 -->
    <el-dialog
      v-el-drag-dialog
      ref="dialog__wrapper"
      id="data-selector"
      key="data-selector"
      :close-on-click-modal="false"
      :visible.sync="listViewVisiable"
      title="选择数据"
      style="min-width: 70%"
      height="calc(100vh - 100px)"
      width="900px"
      append-to-body
      v-if="listViewVisiable"
      @closed="handleListViewClosed"
    >
      <ListView
        ref="listViewDataTable"
        :listViewInfo="listViewInfo"
        :cache="specCacheData.ListView"
        @WriteListSpecSelectedData="WriteListSpecSelectedData"
        @WriteListCleanFillRange="WriteListCleanFillRange"
      ></ListView>
      <div
        v-if="line"
        class="line"
        v-elDragWidth:false="$refs.dialog__wrapper"
        @changeDone="() => {}"
      ></div>
    </el-dialog>
  </div>
</template>

<script>
import dataSpec from './mixins/dataSpec'
import * as math from 'mathjs'
import email from './mixins/email'
import '@/views/Report/FormEditor/assets/font/iconfont.css'
import WLocation from '@/views/Report/FormEditor/extendForms/WLocation'
import WSign from '@/views/Report/FormEditor/extendForms/WSign'
import WList from '@/views/Report/FormEditor/extendForms/WList'
import WImageUpload from '@/views/Report/FormEditor/extendForms/WImageUpload'
import WSingleImageUpload from '@/views/Report/FormEditor/extendForms/WSingleImageUpload'
import WAttachmentUpload from '@/views/Report/FormEditor/extendForms/WAttachmentUpload'
import ListView from '@/views/Report/ReportEditor/ListView/index.vue'
export default {
  name: 'formitem',
  mixins: [email, dataSpec],
  provide() {
    return {
      bindWidgets: () => this.bindWidgets
    }
  },
  inject: ['structure', 'formDisabled'],
  components: {
    WImageUpload,
    WList,
    WSign,
    WSingleImageUpload,
    WLocation,
    WAttachmentUpload,
    ListView
  },
  props: {
    // 所在表类型
    fromType: {
      type: Number,
      default: () => {
        return 1 // 1: 主表 0: 明细
      }
    },
    // 表单对象
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 表单内的组件对象
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    lockedInfo: {
      type: Object,
      default: () => { return undefined }
    },
    rowIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // 表单全局禁用状态
    formDisabledValue() {
      return this.formDisabled()
    },
    structureList() {
      return this.structure()
    },
    // TODO
    // 数据规范 定位 日期范围
    bindWidgets() {
      const arr = []
      arr.push({
        id: this.item.id,
        name: this.item.name,
        value: this.formData[this.item.id]
      })
      return arr
    },
    sliderValue: {
      get() {
        return math.multiply(this.formData[this.item.id], 100)
      },
      set(newVal) {
        this.$set(this.formData, this.item.id, math.divide((newVal || 0), 100))
      }
    },
    progressValue: {
      get() {
        if (isNaN(this.formData[this.item.id])) {
          return 0
        } else {
          var val = math.format(math.multiply(this.formData[this.item.id], 100), { precision: 14 })
          if (val > 100) {
            val = Math.round(val)
          }
          return val
        }
      }
    },
    // 一控件对应多个字段
    // 时间 滑块
    multipleValue: {
      get() {
        if (this.bindWidgets.length > 1) {
          if (this.item.props.range || (this.item.props.datetype && this.item.props.datetype.indexOf('range') !== -1)) {
            const value = this.bindWidgets.map(s => {
              return s.value
            })
            return value
          } else {
            return this.formData[this.item.id]
          }
        } else if (this.bindWidgets.length === 1) {
          return this.formData[this.item.id]
        }
      },
      set(newVal) {
        if (this.bindWidgets.length > 1) {
          if (this.item.props.range || (this.item.props.datetype && this.item.props.datetype.indexOf('range') !== -1)) {
            this.bindWidgets.map((s, index) => {
              this.$set(this.formData, s.id, newVal ? newVal[index] : '')
            })
          } else {
            this.$set(this.formData, this.bindWidgets[0].id, newVal || '')
          }
        } else if (this.bindWidgets.length === 1) {
          this.$set(this.formData, this.bindWidgets[0].id, newVal || '')
        }
      }
    },
    // 下拉 多选 级联
    stringOrArrayValue: {
      get() {
        if ((this.item.componentType === 'Select' && !this.item.single) || this.item.componentType === 'Checkbox' || this.item.componentType === 'Cascader') {
          if (this.formData[this.item.id] && this.item.componentType !== 'Cascader') {
            return this.formData[this.item.id].split(',')
          } else if (this.item.componentType === 'Cascader') {
            if (this.formData[this.item.id] && !this.cascaderTempValue) {
              if (this.cascaderData && this.cascaderData.length) {
                const dataRow = this.cascaderData.find(item => item.label === this.formData[this.item.id])
                if (dataRow) {
                  return [dataRow.value]
                }
              }
              this.cascaderData.push({ label: this.formData[this.item.id], value: '0', temp: true })
              return ['0']
            } else {
              return this.cascaderTempValue
            }
          } else {
            return []
          }
        } else {
          return this.formData[this.item.id]
        }
      },
      set(newVal) {
        if ((this.item.componentType === 'Select' && !this.item.single) || this.item.componentType === 'Checkbox' || this.item.componentType === 'Cascader') {
          if (newVal.length === 0 && this.item.componentType !== 'Cascader') {
            this.$set(this.formData, this.item.id, null)
          } else if (this.item.componentType === 'Cascader') {
            this.cascaderTempValue = newVal
            this.setRelativeValue(newVal)
          } else {
            this.$set(this.formData, this.item.id, newVal.join(','))
          }
        } else {
          this.$set(this.formData, this.item.id, newVal)
        }
      }
    },
    yearValue: {
      get() {
        try {
          return '' + (new Date(this.formData[this.item.id]).getFullYear())
        } catch (ex) {
          return '' + (new Date().getFullYear())
        }
      },
      set(val) {
        if (!val) {
          this.$set(this.formData, this.item.id, '')
          return
        }
        this.$set(this.formData, this.item.id, val + '-1-1')
      }
    },
    monthValue: {
      get() {
        var date
        try {
          if (this.formData[this.item.id]) {
            date = new Date(this.formData[this.item.id])
          } else {
            return ''
          }
        } catch (ex) {
          date = new Date()
        }
        return `${date.getFullYear()}-${date.getMonth() + 1}-1`
      },
      set(val) {
        if (!val) {
          this.$set(this.formData, this.item.id, '')
          return
        }
        this.$set(this.formData, this.item.id, val + '-1')
      }
    },
    dateValue: {
      get() {
        var date
        try {
          if (this.formData[this.item.id]) {
            date = new Date(this.formData[this.item.id])
          } else {
            return ''
          }
        } catch (ex) {
          date = new Date()
        }
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      },
      set(val) {
        if (!val) {
          this.$set(this.formData, this.item.id, '')
          return
        }
        this.$set(this.formData, this.item.id, val)
      }
    },
    timeValue: {
      get() {
        var date
        try {
          if (this.formData[this.item.id]) {
            date = new Date(this.formData[this.item.id])
          } else {
            return ''
          }
        } catch (ex) {
          date = new Date()
        }
        return date
      },
      set(val) {
        if (!val) {
          this.$set(this.formData, this.item.id, '')
          return
        }
        var dateNow = new Date()
        this.$set(this.formData, this.item.id, `${dateNow.getFullYear()}-${dateNow.getMonth() + 1}-${dateNow.getDate()} ${val}`)
      }
    },
    datetimeValue: {
      get() {
        var date
        try {
          if (this.formData[this.item.id]) {
            date = new Date(this.formData[this.item.id])
          } else {
            return ''
          }
        } catch (ex) {
          date = new Date()
        }
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
      },
      set(val) {
        if (!val) {
          this.$set(this.formData, this.item.id, '')
          return
        }
        var date = new Date(val)
        this.$set(this.formData, this.item.id, `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`)
      }
    }
  },
  watch: {
    listViewVisiable(newVal) {
      setTimeout(() => {
        this.line = newVal
      }, 500)
    }
  },
  data() {
    return {
      dateTime: [409, 430, 410, 431, 411, 432, 416, 417, 418, 419],
      cascaderTempValue: null,
      line: false,
      datePickerType: {
        '401': 'year',
        '402': 'year',
        '403': 'month',
        '421': 'month',
        '404': 'month',
        '422': 'month',
        '405': 'month',
        '423': 'month',
        '412': 'month',
        '406': 'date',
        '424': 'date',
        '407': 'date',
        '408': 'date',
        '426': 'date',
        '413': 'date',
        '414': 'date',
        '425': 'date',
        '427': 'date',
        '428': 'date',
        '415': 'date',
        '429': 'date',
        '409': 'datetime',
        '430': 'datetime',
        '410': 'datetime',
        '431': 'datetime',
        '411': 'datetime',
        '432': 'datetime',
        '416': 'time',
        '417': 'time',
        '418': 'time',
        '419': 'time'
      }
    }
  },
  methods: {
    dateFormatterMap(dataType) {
      switch (dataType) {
        case 401:
          // 2019
          return 'yyyy'
        case 402:
          // 2019年
          return 'yyyy年'
        case 403:
          // 2019-1
          return 'yyyy-M'
        case 421:
          // 2019-1
          return 'yyyy-MM'
        case 404:
          // 2019/1
          return 'yyyy/M'
        case 422:
          // 2019/1
          return 'yyyy/MM'
        case 405:
          // 2019年1月
          return 'yyyy年M月'
        case 423:
          // 2019年1月
          return 'yyyy年MM月'
        case 412:
          // 1月
          return 'M月'
        case 406:
          // 2019-1-1
          return 'yyyy-M-d'
        case 424:
          // 2019-1-1
          return 'yyyy-MM-dd'
        case 407:
          // 2019/1/1
          return 'yyyy/M/d'
        case 425:
          // 2019/1/1
          return 'yyyy/MM/dd'
        case 408:
          // 2019年1月1日
          return 'yyyy年M月d日'
        case 426:
          // 2019年1月1日
          return 'yyyy年MM月dd日'
        case 413:
          // 1-1
          return 'M-d'
        case 427:
          // 1-1
          return 'MM-dd'
        case 414:
          // 1/1
          return 'M/d'
        case 428:
          // 1/1
          return 'MM/dd'
        case 415:
          // 1月1日
          return 'M月d日'
        case 429:
          // 1月1日
          return 'MM月dd日'
        case 409:
          // 2019-1-1 1:01:01
          return 'yyyy-M-d H:mm:ss'
        case 430:
          // 2019-1-1 1:01:01
          return 'yyyy-MM-dd H:mm:ss'
        case 410:
          // 2019/1/1 1:01:01
          return 'yyyy/M/d H:mm:ss'
        case 431:
          // 2019/1/1 1:01:01
          return 'yyyy/MM/dd H:mm:ss'
        case 411:
          // 2019年1月1日 1时01分01秒
          return 'yyyy年M月d日 H时mm分ss秒'
        case 432:
          // 2019年1月1日 1时01分01秒
          return 'yyyy年MM月dd日 H时mm分ss秒'
        case 416:
          // 1:01
          return 'H:mm'
        case 417:
          // 1时01分
          return 'H时mm分'
        case 418:
          // 1:01:01
          return 'H:mm:ss'
        case 419:
          // 1时01分01秒
          return 'H时mm分ss秒'
      }
    },
    handleListViewClosed() {
      if (this.$refs.listViewDataTable) {
        this.$refs.listViewDataTable.listViewData = []
      }
    },
    // 更新事件
    handleUpdate(val) {
      console.log('handleUpdate', this.bindWidgets[0])
      this.$emit('handleUpdate', this.bindWidgets[0])
    },
    // 获取焦点
    handleFocus(ref) {
      if (this.fromType === 0) {
        this.$refs[ref].$el.click()
      }
      this.$nextTick(() => {
        if (ref === 'Select') {
          if (this.fromType === 0 && this.selectValue.length) return
          this.handleGetData()
          this.handleGetArrayData()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.formItem {
  height: 100%;
  .el-rate__item .el-rate__decimal {
    font-style: normal !important;
  }
  .el-date-editor {
    .el-input__inner {
      padding-left: 15px;
    }
    .el-input__prefix {
      left: auto;
      right: 5px;
    }
    .el-input__suffix {
      left: auto;
      right: 28px;
    }
  }

  .el-checkbox {
    // margin-right: 0;
  }
  .el-textarea {
    height: 100%;
    .el-textarea__inner {
      height: 100%;
    }
  }
  .el-input-number {
    input {
      text-align: left;
    }
  }
}
</style>
